import { AxiosPromise, AxiosRequestConfig } from "axios";
import { IMockRouteConfig, Mockios }        from "./Mockios";
import { INewsStoryDto }                    from "@/types";
import { MockRouteMatcher }                 from "./MockRouteMatcher";

export class NewsMockService {
    public static getRoutes(): IMockRouteConfig[] {
        return [
            {
                result: this.getHomePageNewsStories,
                isMatch: (rq) =>
                    MockRouteMatcher.isMethodAndPathMatch("get", `News/GetHomePageNewsStories`, rq),
            }
        ];
    }
    private static getHomePageNewsStories(request: AxiosRequestConfig): AxiosPromise<INewsStoryDto[]> {
        return Mockios.ok(request, [{
            Id: 4,
            Title: "New AI technology brings sentience to forklifts!",
            StoryText: "Forklifts now pondering meaning of life and partying instead of doing their jobs. Stocks continue to plummet",
            StorySummary: "Is this the end? Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
            PostDate: "2019-09-18T00:00:00",
            HomeExpirationDate: "2020-12-31T00:00:00",
            SiteExpirationDate: "2021-12-31T00:00:00",
            NewFolderId: 1,
            ImageId: 2,
            BrandAuthorization: 3,
            Region: 4,
            Categories: [
                {
                    NewsCategoryName: "Breaking News",
                    IsDepartment: false
                },
                {
                    NewsCategoryName: "Cool People",
                    IsDepartment: true
                },
                {
                    NewsCategoryName: "AI",
                    IsDepartment: false
                }
            ]
        }]);
    }
}
